export default (state = true, action) => {
  switch (action.type) {
    case "CHANGE_LOADING":
      return action.loadingInProgress;
    default:
      return state;
  }
};
